import LanguagesContainer from 'components/Languages/LanguagesContainer'
import LanguagesPresentation from 'components/Languages/LanguagesPresentation'
import LanguagesData from 'components/Languages/LanguagesData'
import SiteCard from 'components/Languages/SiteCard'

export default {
  Container: LanguagesContainer,
  Presentation: LanguagesPresentation,
  Data: LanguagesData,
  SiteCard,
}
